/**
 * A category's code on its card banner colour, in its ink colour — the band
 * printed across every card of that category, at chip size. No colour set →
 * a neutral outline, the code in ordinary ink.
 */
export function CategoryBanner({ code, cardColor, inkColor, size = "sm", title }: { code: string; cardColor: string | null; inkColor: string | null; size?: "sm" | "lg"; title?: string }) {
	const box = size === "sm" ? "h-[1.5rem] min-w-[2.75rem] px-[0.5rem] text-[0.75rem]" : "h-[2.25rem] min-w-[3.75rem] px-[0.75rem] text-[1rem]";
	return cardColor ? (
		<span
			title={title}
			className={`inline-grid shrink-0 place-items-center rounded-[0.3125rem] font-bold tracking-[0.04em] whitespace-nowrap ${box}`}
			style={{ background: cardColor, color: inkColor ?? "#ffffff" }}
		>
			{code}
		</span>
	) : (
		<span title={title} className={`inline-grid shrink-0 place-items-center rounded-[0.3125rem] border border-dashed border-gms-line-2 font-bold tracking-[0.04em] whitespace-nowrap text-gms-navy-ink ${box}`}>
			{code}
		</span>
	);
}
